<template>
  <div v-if="frequencySelected">
    <v-alert color="var(--blue-100)" class="mt-11" v-if="isAdvisedSeller">
      <div class="d-flex flex-no-wrap">
        <div class="mr-3">
          <v-icon color="var(--blue-500)">mdi-information</v-icon>
        </div>
        <div v-if="paymentFrequency === ANNUAL">
          <p>
            Direct Debits are protected by a guarantee, would you like me to
            read this to you? <br />
            Yes? - Please click:
            <a
              href="https://www.directdebit.co.uk/direct-debit-explained/direct-debit-guarantee/"
              target="_blank"
              >Direct Debit Guarantee</a
            >
            <br />
            No? - This can be found on the direct debit website:
            <a
              href="https://www.directdebit.co.uk/direct-debit-explained/direct-debit-guarantee/"
              target="_blank"
              >Direct Debit Guarantee</a
            >
          </p>
          <p>
            It takes 10 working days to set up a new direct debit and the date
            of the first payment will be confirmed in your insurance documents.
          </p>
        </div>
        <div v-if="hasCreditAgreement">
          <p>
            Please read: <br />
            I will confirm the full details of the credit agreement in writing;
            however, I will now explain the key points of the instalment
            facility, which you should consider carefully. The key points are: ·
            The finance facility is provided by Paymentshield Limited · [For
            {{ premium.CreditDetails.TotalNumberOfPayments }}
            monthly payments: the loan amount includes interest charges at
            {{ premium.CreditDetails.FixedInterestRate | formatPercent }}, which
            represents an APR of
            {{ premium.CreditDetails.Apr | formatPercent }}. The premiums will
            be collected by 1 monthly instalment of
            {{ premium.CreditDetails.InitialPayment | formatCurrency }} and
            {{ premium.CreditDetails.NumberOfSubsequentPayments }}
            subsequent monthly instalments of
            {{ premium.CreditDetails.SubsequentPayments | formatCurrency }}]
          </p>
          <p v-if="paymentFrequency === MONTHLY_3_MONTHS_DEFERRED">
            Please note that this is a 12-month policy with the first three
            months deferred. If this policy is cancelled early, you will be
            charged for this policy on a pro rata daily basis. If no payments
            are received on this policy, the policy will be backdated to
            inception with no cover honoured. On renewal, the policy will revert
            to a 12 monthly payment plan.
          </p>
          <p>
            By selecting the monthly payment option, you've chosen to enter into
            a credit agreement. Failure to keep up the payments is a breach of
            this agreement and may result in the cancellation of your insurance
            policy. Please confirm that the repayments are affordable, and you
            are happy to enter into a credit agreement by answering yes. You
            have the right to withdraw from the credit agreement if you tell us
            within 14 days from when the policy starts. If you do, you will have
            to repay any credit and you will be responsible for making
            alternative arrangements to pay for your cover as your policy may be
            cancelled. If you feel the payments may not be affordable, please
            consider other payment options. Do you have any questions?
          </p>
          <p>
            Direct Debits are protected by a guarantee, would you like me to
            read this to you? <br />
            Yes? - Please click:
            <a
              href="https://www.directdebit.co.uk/direct-debit-explained/direct-debit-guarantee/"
              target="_blank"
              >Direct Debit Guarantee</a
            >
            <br />
            No? - This can be found on the direct debit website:
            <a
              href="https://www.directdebit.co.uk/direct-debit-explained/direct-debit-guarantee/"
              target="_blank"
              >Direct Debit Guarantee</a
            >
          </p>
          <p>
            It takes 10 working days to set up a new direct debit and the date
            of the first payment will be confirmed in your insurance documents.
          </p>
        </div>
      </div>
    </v-alert>

    <v-alert
      color="var(--blue-100)"
      class="mt-11 mb-0 application-monthly-confirmation__wrapper"
      v-else-if="hasCreditAgreement"
    >
      <div class="d-flex flex-no-wrap">
        <div class="mr-3">
          <v-icon color="var(--blue-500)">mdi-information</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Important!</span> By selecting the
          monthly payment option you've chosen to enter into a credit agreement.
          Failure to keep up with payments is a breach of this agreement and may
          result in the cancellation of your insurance policy. Please tick the
          box below to confirm that the repayments are affordable and you're
          happy to enter into a credit agreement. If you feel the payments may
          not be affordable, please consider other payment options.
        </div>
      </div>
    </v-alert>

    <template v-for="(item, index) in question.Questions">
      <component
        v-if="item.IsVisible"
        :key="index"
        :is="item.AnswerControlType"
        :question="item"
        class="margin-monthly-confirm-checkbox"
      ></component>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import {
  APPLICATION_MODULE,
  QUESTIONS_MODULE,
} from "@/store/types/module-types";
import CheckboxBase from "@/components/Checkboxes/CheckboxBase";
import {
  ANNUAL,
  MONTHLY_3_MONTHS_DEFERRED,
  MONTHLY,
} from "@/constants/common.constants";
import PremiumBreakdownMixin from "@/Mixins/PremiumBreakdownMixin";

export default {
  name: "LayoutApplicationMonthlyConfirmation",
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  components: {
    CheckboxBase,
  },
  mixins: [PremiumBreakdownMixin],
  data() {
    return {
      MONTHLY,
      MONTHLY_3_MONTHS_DEFERRED,
      ANNUAL,
    };
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isAdvisedSeller"]),
    ...mapGetters(APPLICATION_MODULE, ["selectedQuote"]),
    ...mapState(APPLICATION_MODULE, ["questionMap"]),
    hasCreditAgreement() {
      return (
        this.paymentFrequency === MONTHLY ||
        this.paymentFrequency === MONTHLY_3_MONTHS_DEFERRED
      );
    },
    frequencySelected() {
      return this.paymentFrequency > "";
    },
    paymentFrequency() {
      return this.questionMap.PaymentFrequency.Value;
    },
    premium() {
      const breakdown = this.buildPremiumBreakdownModel(
        this.selectedQuote,
        "DirectDebit",
        this.paymentFrequency
      );
      return breakdown.premium;
    },
  },
};
</script>

<style lang="scss" scoped>
.margin-monthly-confirm-checkbox {
  margin: 10px 0 25px 0;
}
</style>
